<div class="anomaly">
  <app-summary-anomaly-item-cargo-tracking class="anomaly__item" [color]="colors[anomalies.length]" [cargos]="cargos"
    [amount]="cargos?.length">
  </app-summary-anomaly-item-cargo-tracking>
  <ng-container *ngFor="let anomaly of anomalies; let i = index">
    <app-summary-anomaly-item-cargo-tracking class="anomaly__item" [color]="colors[i]"
      *ngIf="countListAnomaly[anomaly.name]" [anomaly]="anomaly.name" [amount]="countListAnomaly[anomaly.name].length">
    </app-summary-anomaly-item-cargo-tracking>
  </ng-container>
</div>